import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

export const getIsAuthenticated = async (): Promise<AxiosResponse<unknown>> => {
	return api.get('/cityzens/isauthenticated');
};

/** @deprecated Prefer getIsAuthenticated */
export const isUserAuthenticated = getIsAuthenticated;
